export const goalAppearances = ['default', 'on_track', 'at_risk', 'off_track'];
export const isGoalAppearance = value => goalAppearances.includes(value);

/**
 * This is solely here to support Jira only having these values available
 *
 * @private
 * @deprecated please use `GoalAppearance` instead
 */
export const goalStatusValues = ['ON_TRACK', 'AT_RISK', 'OFF_TRACK', 'PENDING', 'COMPLETED', 'CANCELLED', 'PAUSED'];

/**
 * This is solely here to support Jira only having these values available
 *
 * @private
 * @deprecated please use `GoalAppearance` instead
 */